// quad-trie binary format v1
//
// Header (12 bytes)
//   [0..1]  magic         u16 LE  = 0x4754 ('GT')
//   [2]     depth         u8      = trie depth (1-26)
//   [3]     version       u8      = 1
//   [4..7]  nibble_count  u32 LE  = total nibbles in stream
//   [8..11] point_count   u32 LE  = number of leaf points encoded
//
// Body: ⌈nibble_count / 2⌉ bytes
//   Nibbles packed 2 per byte, high nibble first:
//     byte[i] = (nibble[2i] << 4) | nibble[2i+1]
//
// Nibble stream: DFS pre-order over a 4-ary trie
//   Each nibble = 4-bit bitmap of which children (0-3) are present
//   POPCNT(nibble) children follow in order, child 0 first
//   Leaf nodes (level === depth) emit nothing — presence is encoded
//   by the parent's bitmap bit
//
// Coordinate encoding (depth-parameterized):
//   maxCoord = 2^depth - 1
//   lat ∈ [-90,  90] → depth-bit integer: round((lat + 90)  / 180 * maxCoord)
//   lon ∈ [-180,180] → depth-bit integer: round((lon + 180) / 360 * maxCoord)
//   Interleaved as 2*depth-bit Morton code: even bits = lat, odd bits = lon
//   depth levels × 2 bits per level = all bits used, no truncation
//   Cell size: lat ≈ 180/2^depth °, lon ≈ 360/2^depth ° — cells are 2:1 (lon:lat) in angular extent.
//   At depth 15: ~610m lat × ~1220m lon at the equator. "depth N ≈ Xm" refers to the lat axis.

export const MAGIC_0 = 0x47 // 'G'
export const MAGIC_1 = 0x54 // 'T'
export const FORMAT_VERSION = 1
export const HEADER_SIZE = 12
